module.exports = __webpack_public_path__ + "static/media/floor_plan.91c58502.svg";